import { agencyCommissionModeMapping, billingMomentMapping, paymentModeMapping } from '../../misc'
import { clientsGetters } from './getters'

export const columnDefs = () => [
  {
    headerName: 'Datos del cliente',
    headerClass: 'column-group-1',
    children: [
        {
            headerName: 'ID',
            valueGetter: clientsGetters.getId,
            width: 150,
            filter: false,
            checkboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: true,
            pinned: 'left'
          },
          {
            headerName: 'Razón social',
            valueGetter: clientsGetters.billingInformation.getLegalName,
            filter: false,
            width: 200
          },
          //From ODOO
          {
            headerName: 'ID anunciante',
            valueGetter: clientsGetters.getId,
            filter: false,
            width: 200
          },
          {
            headerName: 'Nombre de fantasía',
            valueGetter: clientsGetters.getFantasyName,
            filter: false,
            width: 200
          },
          {
            headerName: 'ID Holding',
            valueGetter: clientsGetters.getHoldingId,
            filter: false,
            width: 200
          },
          {
            headerName: 'Holding agencia',
            valueGetter: clientsGetters.holdingNameGetter,
            filter: false,
            width: 200
          },
          {
            headerName: 'Dirección',
            valueGetter: clientsGetters.billingInformation.getAddress,
            filter: false,
            width: 200
          },
    ]
    },
    {
      headerName: 'Datos Facturación',
      headerClass: 'column-group-2',
      children: [
        {
          headerName: 'Número de identificación',
          valueGetter: clientsGetters.billingInformation.getTaxId,
          filter: false,
          width: 200
        },
        //queda
        {
          headerName: 'Modo de facturación',
          valueGetter: clientsGetters.properties.getBillingMoment,
          filter: false,
          width: 200,
          refData: billingMomentMapping()
        },
        //queda
        {
          headerName: 'Modo de pago',
          valueGetter: clientsGetters.properties.getPaymentMode,
          filter: false,
          width: 200,
          refData: paymentModeMapping()
        },
        //queda
        {
          headerName: 'Plazo de pago',
          valueGetter: clientsGetters.properties.getPaymentTimeLimit,
          filter: false,
          width: 200
        },
        {
          headerName: 'Plazo de cobro',
          valueGetter: clientsGetters.properties.getChargeTimeLimit,
          filter: false,
          width: 200
        },
        //queda
        {
          headerName: 'Modo comisión agencia',
          valueGetter: clientsGetters.properties.getAgencyCommissionMode,
          filter: false,
          width: 250,
          refData: agencyCommissionModeMapping()
        }
      ]
    }
]
